import type { ReactNode } from "react";
import { cx } from "../utils/cx";
import styles from "./Panel.module.css";

interface PanelProps {
  /** Optional panel header (Title role — 14px/600). */
  title?: ReactNode;
  className?: string;
  children: ReactNode;
}

/**
 * A primary content container on the page background (style-guide.md:
 * Panels and Cards). Uses --surface. For a nested/repeatable container on
 * top of a panel, use <Card> instead.
 */
function Panel({ title, className, children }: PanelProps) {
  return (
    <section className={cx(styles.panel, className)}>
      {title !== undefined && <h2 className={styles.header}>{title}</h2>}
      {children}
    </section>
  );
}

export default Panel;
